export default __webpack_public_path__ + "static/media/social-youtube.5ea49a55.svg";